import { render } from "./ChangePasswordForm.vue?vue&type=template&id=b35315e4&scoped=true&ts=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=b35315e4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35315e4"]])

export default __exports__